module.exports = __webpack_public_path__ + "img/main-01-01.ab6f8f3e.png";